// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
    // baseUrl: 'http://192.168.18.5:12001',
    // baseUrl: 'https://demo-lamp.movingwalls.com',
    // baseUrl: 'https://mw-lamp-db.herokuapp.com',
    // baseUrl: "https://staging-lamp-api.movingwalls.com",
    baseUrl: "https://lamp.movingwalls.com",
    // baseUrl:"http://localhost:12000",
    madBaseUrlToConnect: "https://test-buyers.movingwalls.com/",
    madUserName: "test7",
    madPassword: "Test123"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
